var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAgent() || _vm.isAdmin())?_c('div',[_c('agent-us-returned-goods-custody')],1):_vm._e(),(_vm.isSeller())?_c('div',[_c('seller-us-returned-goods-custody')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }